import React from "react";
import { Spin } from "antd";
import { Link, useParams } from "react-router-dom";
import { useVerifyEmailQuery } from "store/api";

const VerifyEmail = () => {
  const { token } = useParams();

  const { isFetching, isSuccess, isError, error } = useVerifyEmailQuery(token);

  return (
    <div className="h-full flex items-center justify-between">
      {isFetching ? (
        <Spin tip="Please Wait..." size="large" spinning={isFetching}>
          <div className="text-center">
            <h1 className="text-3xl font-bold text-blue-600">
              Verifying Your Account
            </h1>
          </div>
        </Spin>
      ) : isSuccess || !isError ? (
        <>
          <div className="text-center">
            <h1 className="text-3xl font-bold text-green-600">
              Account Verified
            </h1>
            <p className="text-gray-500">You can now login to your account</p>
            <Link to="/" className="text-blue-600">
              Click here to login
            </Link>
          </div>
        </>
      ) : (
        <div className="text-center">
          <h1 className="text-3xl font-bold text-red-600">
            {("data" in (error || {}) && (error as any).data?.error) ||
              "Verification Failed"}
          </h1>
          <p className="text-gray-500">Something Went Wrong</p>
          <Link to="mailto:save-invest.club" className="text-blue-600">
            Contact Support Team For Help
          </Link>
        </div>
      )}
    </div>
  );
};

export default VerifyEmail;
